import React from "react";
import {IApiUserProto, space} from "../provider_api";
import IApiBookingProto = space.kenko.proto.IApiBookingProto;

// This returns text with a green, yellow or red background
// depending on the payment status of the booking.
export const PaymentStatusWidget = (props: {booking?: IApiBookingProto}) => {

  let paymentInfo = props.booking?.details?.paymentInfo;
  if (!paymentInfo) {
    return 'N/A';
  }
  
  if (paymentInfo.prepaidPackage) {
    return <div className={'GreenHighlight'}>Paid: package</div>
  }

  if (paymentInfo.prepaidSingleClassCredit) {
    return <div className={'GreenHighlight'}>Paid: single class</div>
  }

  if (paymentInfo.postpaidExternalPayment) {
    return <div className={'GreenHighlight'}>Paid: external</div>
  }

  if (paymentInfo.postpaidReservation) {
    if (props.booking?.startTimeMs as number > Date.now()) {
      return <div className={'YellowHighlight'}>Unpaid: reserved</div>;
    } else {
      return <div className={'RedHighlight'}>Unpaid</div>;
    }
  }

  // if (paymentInfo.thirdPartyPayment) {
  //   return <div className={'GreenHighlight'}>Paid via stripe</div>
  // }

  return "N/A";
}

export const bookingTitle = (booking: IApiBookingProto | null | undefined) => {
  if (booking?.details?.class) {
    return booking.details.class.className;
  }
  
  if (booking?.details?.service) {
    let service = booking.details.service;
    return service.serviceName + ' with ' + booking.details?.service?.practitionerName;
  }

  return 'Error';
}

export const fullName = (user: IApiUserProto | null | undefined) => {
  if (!user) {
    return "";
  }
  
  if (user.givenName || user.familyName) {
    return user.givenName + ' ' + user.familyName;
  }
  
  // A terrible fallback but better than nothing?
  return user.contactEmail;
}